import { useTranslation } from '@cobliteam/i18n';
import Icon from '@cobliteam/ui/icons';
import type { UIMessage } from 'ai';
import { type ChatMessagePart, shouldShowAssistantLoadingFallback } from '../AIChatMessages/utils';
import { Shimmer } from './Shimmer';

interface LoadingProps {
  message: UIMessage;
  isAssistant: boolean;
  hideTools?: boolean;
}

const Loading = ({ message, isAssistant, hideTools = false }: LoadingProps) => {
  const { t } = useTranslation('ai');

  if (!isAssistant) return null;

  const parts = message.parts as ChatMessagePart[];

  if (!shouldShowAssistantLoadingFallback(parts, { hideTools })) return null;

  return (
    <div className='mt-2 flex w-full items-center gap-1 px-3'>
      <Icon name='loader-circle' size='sm' color='gray-dark' className='animate-spin' aria-hidden='true' />
      <Shimmer duration={1} className='text-sm'>
        {t('tool_loading_fallback')}
      </Shimmer>
    </div>
  );
};

export default Loading;
